

import React, { useEffect, useState } from "react";
import {
  Avatar,
  Backdrop,
  Button,
  DocumentsList,
  LogoLoader,
  Modal,
  StatusTags,
  TableAdv,
} from "../../../../../components";
import { mapTableRows } from "../../../../../utils/mapTableRows";
import { dateFormator } from "../../../../../utils/dateFormator";
import { honeBData } from "../../../../../assets/data/candidatesData";
import { useDispatch, useSelector } from "react-redux";
import { getAllImmigrations, getAllImmigrationsStart, getCurrentEmployeeImmigration } from "../../../../../redux/slices/immigration/immigrationSlice";
import { transformFiles } from "../../../../../utils/transformFiles";
import { totalCountStart } from "../../../../../redux/slices/totalCount/totalCountSlice";
import { usePagination } from "../../../../../hooks";
import { H1BStatus } from "../../../../../assets/data/enumData";

const HoneB = ({ onEdit }) => {
  const dispatch = useDispatch();
  const [documentModal, setDocumentModal] = useState(false);
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  // const [selectedRow, setSelectedRow] = useState(null);
  const {
    employeeProfileUiid,
    currentEmployee: { employeeDetails, loadedTabs },
  } = useSelector((state) => state.employee);
       const {currentEmployeeImmigration,loading } = useSelector(
      (state) => state.immigration
    );
 const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {
      // dispatch(getAccountPayablesStart({ page: newPage, limit: newLimit }));
    }
  );
  console.log("currentEmployeeImmigration",currentEmployeeImmigration);
  const { value } = useSelector((state) => state.totalCount);
    const totalCount = value?.ceh1b?.data || 0;
  const h1bTableData = currentEmployeeImmigration?.h1b || [];
  console.log("h1bTableData",h1bTableData);
    const isLoading = loading;
  // const tableData =
  //   Array.isArray(immigrationsTableData?.data?.h1b) &&
  //   immigrationsTableData.data.h1b.length > 0
  //     ? immigrationsTableData?.data?.h1b
  //     : [];
    //   const tableDataLCA =
    // Array.isArray(immigrationsTableData?.data?.lca) &&
    // immigrationsTableData.data.lca.length > 0
    //   ? immigrationsTableData.data.lca
    //   : [];
  // const updateData = tableData.map((data) => {
  //   return {
  //     ...data, // Spread the existing data
  //     employeeName: employeeDetails?.firstName, // Add the firstName from employeeDetails
  //   };
  // });
  const handleclick = () => {
    setDocumentModal(!documentModal);
  };

  const handleEdit = (row) => {
    // Pass the selected row data to the parent component
    if (onEdit && typeof onEdit === "function") {
      onEdit(row);
    }
  };
  const handleDocumentsModal = (documents) => {
    if (documents.length > 0) {
      const updatedDocuments = documents.map((data) => {
        return { filePath: data }; // return an object with filePath
      });
      setSelectedDocuments(updatedDocuments); // update the selected documents state
    }

    setDocumentModal(true); // open the modal
  };

  // const tableData = [
  //   {
  //     employeeName: "Ramesh Manthri",
  //     honeBType: "Extension",
  //     filedOn: "2021-11-01T00:00:00.000Z",
  //     receiptNumber: "EAC2014951144",
  //     status: "Rejected",
  //     expiryDate: "2021-11-01T00:00:00.000Z",
  //     documents: "2",
  //     hOneBStatus: "Approved", // Added these fields to match the form
  //     processingType: "Premium",
  //     basisOfH1B: "New Employment",
  //     lcas: "LCA12345",
  //     priority: "High",
  //     recordStatus: "Active",
  //     comments: "This is a sample H-1B extension case",
  //   },
  // ];

  const columns = [
    {
      key: "employeeId",
      label: "Employee Name",
      render: (row) => (
        <div className="flex items-center gap-1">
          <span className="text-linkblue">{row.employeeId?.firstName}</span>
        </div>
      ),
      sortable: false,
    },
    {
      key: "processType",
      label: "H-1B Type",
      sortable: false,
      render: (row) => {
              return (
                <StatusTags tag={row?.processType===1?"Premium":row?.processType===2?"Normal":"" || "-"} /> // Fallback to "Unknown" if label is undefined
              );
            },
    },
    {
      key: "status",
      label: "H-1B Status",
      sortable: false,
      render: (row) => {
          const findType = H1BStatus.find((data) => data.value === row?.status)?.label;
              return (
                <StatusTags tag={findType || "-"} /> // Fallback to "Unknown" if label is undefined
              );
            },
    },
    {
      key: "addedOn",
      label: "Filed On",
      render: (row) => dateFormator(row.addedOn, "month-day-year"),
      sortable: false,
    },
    {
      key: "receiptNum",
      label: "Receipt Number",
      sortable: false,
    },
    {
      key: "recordStatus",
      label: "Status",
      render: (row) => <StatusTags tag={row.recordStatus===1?"Active":row.recordStatus===2?"Inactive":"Extension"} />,
      sortable: false,
    },
    {
      key: "expiryDate",
      label: "Expiry Date",
      render: (row) => dateFormator(row.expiryDate, "month-day-year"),
      sortable: false,
    },
    {
      key: "documents",
      label: "Documents",
      // render: (row) => (
      //   <div
      //     className="flex items-center gap-1 flex-row cursor-pointer"
      //     onClick={() => handleclick()}
      //   >
      //     <span className="text-linkblue">{row.documents.length} Docs </span>
      //     <div>
      //       <Button
      //         type="icon"
      //         icon="docs"
      //         size="xs"
      //         variant="text"
      //         color="black"
      //       />
      //     </div>
      //   </div>
      // ),
      render: (row) => {
        return (
          <div
            className={`flex items-center gap-1 flex-row ${
              (row.documents || []).length > 0 && "cursor-pointer"
            }`}
            onClick={
              (row.documents || []).length > 0
                ? () => handleDocumentsModal(row.documents || [])
                : () => {}
            }
          >
            <span className={`${(row.documents || []) > 0 && "text-linkblue"}`}>
              {(row.documents || []).length} Docs{" "}
            </span>
            <div>
              <Button
                type="icon"
                icon="docs"
                size="xs"
                variant="text"
                color="black"
              />
            </div>
          </div>
        );
      },
      sortable: false,
    },
    {
      key: "actions",
      label: "Actions",
      render: (row) => (
        <Button
          type="icon"
          variant="text"
          icon="edit_square"
          size="xs"
          color="info"
          onClick={() => handleEdit(row)}
        />
      ),
    },
  ];

  const mappedRows = mapTableRows(h1bTableData, columns);
  useEffect(() => {
    if (employeeProfileUiid) {
      const runDispatches = async () => {
       const filter={ "employeeId" : { "type": "NONE", "value": employeeProfileUiid } }
       dispatch(
        totalCountStart({
          collection: "h1bs",
          coll: "H1B",
          tname: "ceh1b",
           filters:filter,
        })
      );
      dispatch(
            getCurrentEmployeeImmigration({
              coll: "LCA",
              rsn: "lca",
              limit,
              page,
              ref:"Employee Entity Paper Cert",
              incl:["uiid firstName","businessName"],
              filter,
            })
          );
           // Wait another 500ms
      await new Promise(resolve => setTimeout(resolve, 500));
      dispatch(
        getCurrentEmployeeImmigration({
          coll: "H1B",
          rsn: "h1b",
          limit,
          page,
          ref: "Employee",
          incl: ["uiid firstName"],
          filter,
        })
      );
    }
    runDispatches(); 
    }
  }, [employeeProfileUiid, loadedTabs, dispatch]);
  useEffect(() => {
    
    }, [dispatch, page, limit,loadedTabs]);
  return (
    <div>
      <TableAdv
      tableId={`employee_immigration_honeb`}
        rows={mappedRows}
        columns={columns}
         serverPagination={true}
            totalCount={totalCount}
            hideToolBar={true}
        // toolbarRight={[{ hideToolbar: true }]}
         page={page}
            limit={limit}
            onPaginationChange={setPage}
            onLimitChange={handleLimitChange}
      />
      <Modal
        isOpen={documentModal}
        onClose={() => setDocumentModal(false)}
        title="Document Details"
      >
        <DocumentsList data={selectedDocuments} />
      </Modal>
        <Backdrop isOpen={isLoading}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default HoneB;
